<template>
  <div>
    <div class="portada-portafolio">
      <div class="subportada-portafolio d-flex align-items-center justify-content-center flex-wrap">
        <div class="px-2">
          <h1 class="w-100">Clientes</h1>
        </div>
      </div>
    </div>
    <div class="contenedor-portafolio row justify-content-center w-100 m-0 py-2 py-lg-4">
      <div
        class="contenedor-cliente col-12 col-md-6 row py-3"
        v-for="(item, index) in Clientes"
        :key="index"
      >
        <div class="col-12 col-lg-6 p-0 m-0 pb-3">
          <img class="d-block" :src="item.imagen" :title="item.nombre" />
        </div>
        <div class="col-12 col-lg-6 d-flex flex-wrap justify-content-start">
          <div>
            <h2 class="w-100">{{item.nombre}}</h2>
            <p>
              <b>Teléfono:</b>
              {{item.telefono}}
              <br />
              <b>Dirección:</b>
              {{item.direccion}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["Clientes"])
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
<style scoped>
.portada-portafolio {
  height: 420px;
  width: 100%;
  min-height: 50vh;
  color: white;
  background: #262626;
  background: url("../../assets/images/portadas/portafolio.jpeg");
  background-size: cover;
}
.portada-portafolio h1 {
  font-size: calc(3.5em + 1vh);
  letter-spacing: -0.5px;
}
.portada-portafolio h2 {
  font-size: calc(2.2em + 1vh);
}
.portada-portafolio h2,
h1 {
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}
.subportada-portafolio {
  background: rgba(0, 0, 0, 0.35);
  height: 100%;
  width: 100%;
}
.contenedor-cliente {
  text-align: left;
}

.contenedor-portafolio {
  padding: 0 6%;
}

.contenedor-cliente h2 {
  font-size: 1.26em;
  color: #262626;
}
.contenedor-cliente p {
  font-size: 0.95em;
  color: #666666;
}
.contenedor-cliente img {
  display: block;
  margin: auto;
  height: auto;
  max-width: 100%;
}
</style>